import React, { Component } from "react";
import QuizImg from "./previewQuiz/QuizImg";
import QuizImgBased from "./previewQuiz/QuizImgBased";
import Constant from "../../../Constant";
import QuizBubble from "./previewQuiz/QuizBubble";
import QuizFourPicOneWord from "./previewQuiz/QuizFourPicOneWord";
import QuizMakeSentence from "./previewQuiz/QuizMakeSentence";
import FillInBlank from "./previewQuiz/FillInBlank";
// import ActivityModal from "../modals/ActivityModal";
// import Pause from "../modals/Pause";
// import Quizreport from "../modals/Quizreport";
// import { CSSTransition, TransitionGroup } from "react-transition-group";
// import Query from "../modals/Query";
import Swal from "sweetalert2";
import { Line, Circle } from "rc-progress";
import QuizSideBar from "./previewQuiz/QuizSideBar";
import Fullscreen from "react-full-screen";

export default class PreviewEditQuestion extends Component {
  state = {
    isLoading: false,
    course_details: {
      relateddata: [],
      autoplay: 0
    },
    count: 0,
    open: false,
    chat: [],
    openActivityModel: false,
    openpause: false,
    openreport: false,
    openquery: false,
    session: "",
    unit_details: {
      unit_name: ""
    },
    quiz_list: [
      {
        question_list: [{}],
        quiz_title: ""
      }
    ],
    isFull: false,
    sidebarOpen: false,
    question: {
      question_title: "",
      question_options:[]
    }
  };

  onSetSidebarOpen = open => {
    this.setState({ sidebarOpen: open });
  };
  onOpenModal_pause = () => {
    this.setState({ openpause: true });
  };
  onCloseModal_pause = () => {
    this.setState({ openpause: false });
  };

  onOpenModal_report = () => {
    this.setState({ openreport: true });
  };
  onCloseModal_report = () => {
    this.setState({ openreport: false });
    this.onOpenModal();
  };
  onOpenModal = () => {
    this.setState({ openActivityModel: true });
  };
  onCloseModal = () => {
    //  window.location.href = "#/admin/courses"
    this.setState({ openActivityModel: false });
    this.onOpenModal_query();
  };
  onOpenModal_query = () => {
    this.setState({ openquery: true });
  };
  onCloseModal_query = () => {
    window.location.href = "#/admin/courses"
    this.setState({ openquery: false });
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    localStorage.removeItem("quiz");
    // this.getUnitList();
    // this.getCourseList()
    // this.get_sesssion();
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.question != this.props.question) {
  //     this.setState({ question: this.props.question });
  //     console.log(this.props.question);
  //   }
  // }
  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.question != this.props.question) {
  //     this.setState({ question: this.props.question });
  //     console.log(this.props.question);
  //   }
  //   // if (this.state.count !== prevState.count) {
  //   //   console.log(this.state.count + 1)
  //   //   console.log(this.props.unitDetails.quiz_list[0].question_list.length)
  //   //   if (this.state.count + 1 == this.props.unitDetails.quiz_list[0].question_list.length) {
  //   //   }
  //   // }
  // }
  get_sesssion = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    }
    data.append("language_id", Constant.language_id());
    data.append("main_course_unit_id", that.props.unit_id);
    data.append("coursemaster_id", that.props.course_id);
    fetch(Constant.getAPI() + "/createquizprogress", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          that.setState({ session: json.data.session });
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  getCourseList = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    }
    data.append("list_type", Constant.default_course_cat_list_type());
    data.append("language_id", Constant.language_id());
    //  data.append("category_id",id);
    if (that.props.location.state) {
      data.append("category_id", that.props.location.state.category_id);
    }
    fetch(Constant.getAPI() + "/coursecataloglist", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          for (var i = 0; i < json.data.length; i++) {
            if (that.props.course_id === json.data[i].main_course_id) {
              var obj = {};
              obj.course_id = json.data[i].course_id;
              obj.course_name = json.data[i].course_name;
              obj.course_status = json.data[i].course_status;
              obj.category_id = json.data[i].main_category_id;
              obj.category_name = json.data[i].category_name;
              obj.course_price = json.data[i].course_price;
              obj.course_free_paid_status =
                json.data[i].course_free_paid_status;
              obj.course_image = json.data[i].course_image;
              obj.cover_image_url = json.data[i].cover_image_url;
              obj.catalog_display = json.data[i].catalog_display;
              obj.auto_enroll = json.data[i].auto_enroll;
              obj.course_description = json.data[i].course_description;
              obj.course_code = json.data[i].course_code;
              obj.course_duration = json.data[i].course_duration;
              obj.time_per_day = json.data[i].time_per_day;
              obj.no_of_lesson = json.data[i].no_of_lesson;
              obj.language_id = json.data[i].language_id;
              obj.created_by_details = json.data[i].created_by_details;
              obj.user_subscribed_flag = json.data[i].user_subscribed_flag;
              that.setState({
                course_details: obj,
                isLoading: false,
                user_subscribed_flag: json.data[i].user_subscribed_flag
              });
            }
          }
        } else {
          that.setState({ isLoading: false });
          console.log(json.error);
        }
      });
  };
  getUnitList = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
      data.append("domain_code", Constant.domain_code());
    }
    data.append("main_course_unit_id", that.props.unit_id);
    data.append("main_course_id", that.props.course_id);
    data.append("language_id", Constant.language_id());
    fetch(Constant.getAPI() + "/unitdetails", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          that.setState({
            unit_details: json.data,
            isLoading: false,
            quiz_list: json.data.quiz_list
          });
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found " + json.error);
        }
      });
  };
  nextque = () => {
    if (
      this.state.count <
      this.props.unitDetails.quiz_list[0].question_list.length - 1
    ) {
      this.setState({ count: this.state.count + 1 });
    } else {
      this.setState({ isFull: false });
      if (localStorage.getItem("sk_is_login") === "true") {
        this.savequizanswer();
        this.onOpenModal_report();
      } else {
        Swal.fire("", "Please login to see your scores.", "info");
        window.location.href = "#/admin/courses"
      }
    }
  };
  savequizanswer = () => {
    if (this.props.task_master_id) {
      this.saveTaskProgress(this.props.task_master_id);
    }
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
      data.append("domain_code", Constant.domain_code());
    }
    data.append("main_course_unit_id", that.props.unit_id);
    data.append("language_id", Constant.language_id());
    data.append("session", that.state.session);
    data.append("quiz_answers", localStorage.getItem("quiz"));
    fetch(Constant.getAPI() + "/savequizanswer", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  saveTaskProgress = taskId => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
      data.append("domain_code", Constant.domain_code());
    }
    data.append("main_course_unit_id", that.props.unit_id);
    data.append("coursemaster_id", that.props.course_id);
    data.append("language_id", Constant.language_id());
    data.append("score", 50);
    data.append("points", 50);
    data.append("status", "completed");
    data.append("task_id", taskId);
    fetch(Constant.getAPI() + "/taskprogress", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  playCorrectAudio = () => {
    window.confetti();
    console.log("correct");
    document.querySelector(".correct-audio").play();
    var fullscreen = document.querySelector(".fullscreen-enabled");
    var ctContainer = document.querySelector("#ct-container");
    var canvas = document.querySelector("canvas");
    console.log(canvas);
    if (fullscreen) {
      fullscreen.appendChild(ctContainer);
      ctContainer.appendChild(canvas);
    }
  };
  playIncorrectAudio = () => {
    console.log("incorrect");
    document.querySelector(".incorrect-audio").play();
    var fullscreen = document.querySelector(".fullscreen-enabled");
    var ctContainer = document.querySelector("#ct-container");
    // var canvas = document.querySelector("canvas");
    if (fullscreen) {
      fullscreen.appendChild(ctContainer);
      // fullscreen.appendChild(canvas);
    }
  };
  changeQuestion = key => {
    this.setState({ count: key });
  };

  onBack = () => {
    this.setState({ count: this.state.count - 1 });
  };
  onNext = () => {
    if (
      this.state.count <
      this.props.unitDetails.quiz_list[0].question_list.length - 1
    ) {
      this.setState({ count: this.state.count + 1 });
    } else {
      if (localStorage.getItem("sk_is_login") === "true") {
        this.savequizanswer();
        this.onOpenModal_report();
      } else {
        Swal.fire("", "Please login to see your scores.", "info");
        window.location.href = "#/admin/courses"
      }
    }
  };

  onFullScreen = () => {
    this.setState({ isFull: !this.state.isFull });
  };
  render() {
    return (
      <div className="w-100">
        <Fullscreen
          enabled={this.state.isFull}
          onChange={isFull => this.setState({ isFull })}
        >
          <div className="container right-panel media-player shadow p-0">
            {/* <QuizSideBar
              count={this.state.count}
              list={this.props.questionsList}
              question={this.props.unitDetails.unit_name}
              changeQuestion={this.changeQuestion}
              sidebarOpen={this.state.sidebarOpen}
              onSetSidebarOpen={this.onSetSidebarOpen}
            /> */}

            {/* {
              this.state.quiz_list[0].movie_video_url !== ""
                ?
                <div class="fullscreen-bg">
                  <video loop muted autoplay class="fullscreen-bg__video">
                    <source src={this.state.quiz_list[0].movie_video_url}></source>
                  </video>
                </div>
                :
                null
            } */}
            <div
              className="container main-container-quiz edit-quiz new-quiz mx-auto"
              style={{
                backgroundColor:
                  this.state.quiz_list[0].color_code !== ""
                    ? this.state.quiz_list[0].color_code
                    : null,
                backgroundImage:
                  this.state.quiz_list[0].background_media_url !== ""
                    ? "url('" +
                      this.state.quiz_list[0].background_media_url +
                      "')"
                    : ""
              }}
            >
              <section className="quiz-section bg">
                <div className="container-fluid">
                  {this.props.question.game_type_id == 1 ? (
                    <FillInBlank
                      unitDetails={this.props.question}
                      parentMethod={this.nextque}
                      Details={this.props.unitDetails}
                      course_id={this.props.course_id}
                      unit_id={this.props.unit_id}
                      count={this.state.count}
                      playCorrectAudio={this.playCorrectAudio}
                      playIncorrectAudio={this.playIncorrectAudio}
                    />
                  ) : this.props.question.game_type_id == 2 ? (
                    <QuizFourPicOneWord
                      unitDetails={this.props.question}
                      Details={this.props.unitDetails}
                      course_id={this.props.course_id}
                      unit_id={this.props.unit_id}
                      count={this.state.count}
                      parentMethod={this.nextque}
                      playCorrectAudio={this.playCorrectAudio}
                      playIncorrectAudio={this.playIncorrectAudio}
                    />
                  ) : this.props.question.game_type_id == 3 ? (
                    <FillInBlank
                      unitDetails={this.props.question}
                      parentMethod={this.nextque}
                      Details={this.props.unitDetails}
                      course_id={this.props.course_id}
                      unit_id={this.props.unit_id}
                      count={this.state.count}
                      playCorrectAudio={this.playCorrectAudio}
                      playIncorrectAudio={this.playIncorrectAudio}
                    />
                  ) : this.props.question.game_type_id == 4 ? (
                    <QuizBubble
                      unitDetails={this.props.question}
                      parentMethod={this.nextque}
                      Details={this.props.unitDetails}
                      course_id={this.props.course_id}
                      unit_id={this.props.unit_id}
                      count={this.state.count}
                      playCorrectAudio={this.playCorrectAudio}
                      playIncorrectAudio={this.playIncorrectAudio}
                    />
                  ) : this.props.question.game_type_id == 5 ? (
                    this.props.question.answer_type_id == 2 &&
                    this.props.question.question_type_id == 7 ? (
                      <QuizImgBased
                        unitDetails={this.props.question}
                        parentMethod={this.nextque}
                        Details={this.props.unitDetails}
                        course_id={this.props.course_id}
                        unit_id={this.props.unit_id}
                        count={this.state.count}
                        playCorrectAudio={this.playCorrectAudio}
                        playIncorrectAudio={this.playIncorrectAudio}
                      />
                    ) : (
                      <QuizImg
                        unitDetails={this.props.question}
                        parentMethod={this.nextque}
                        Details={this.props.unitDetails}
                        course_id={this.props.course_id}
                        unit_id={this.props.unit_id}
                        count={this.state.count}
                        playCorrectAudio={this.playCorrectAudio}
                        playIncorrectAudio={this.playIncorrectAudio}
                      />
                    )
                  ) : this.props.question.game_type_id == 8 ? (
                    <p>Audio Recognition</p>
                  ) : this.props.question.game_type_id == 9 ? (
                    <QuizMakeSentence
                      unitDetails={this.props.question}
                      parentMethod={this.nextque}
                      Details={this.props.unitDetails}
                      course_id={this.props.course_id}
                      unit_id={this.props.unit_id}
                      count={this.state.count}
                      playCorrectAudio={this.playCorrectAudio}
                      playIncorrectAudio={this.playIncorrectAudio}
                    />
                  ) : (
                    <div />
                  )}

                  {/* <Pause
                    open={this.state.openpause}
                    course_id={this.props.course_id}
                    close={this.onCloseModal_pause}
                  />
                  <ActivityModal
                    open={this.state.openActivityModel}
                    course_id={this.props.course_id}
                    close={this.onCloseModal}
                  />
                  <Query
                    open={this.state.openquery}
                    course_id={this.props.course_id}
                    close={this.onCloseModal_query}
                    game_id={
                      this.state.quiz_list != null
                        ? this.props.unitDetails.quiz_list[0].question_list[
                          this.state.count
                        ].game_type_id
                        : ""
                    }
                    coursemaster_id={this.props.unitDetails.coursemaster_id}
                  />
                  <Quizreport
                    open={this.state.openreport}
                    course_id={this.props.course_id}
                    close={this.onCloseModal_report}
                    name={this.props.unitDetails.unit_name}
                  /> */}
                </div>
              </section>

              <audio className="correct-audio" autoPlay>
                <source src="./theme/audio/correct2.mp3" type="audio/ogg" />
                <source src="./theme/audio/correct2.mp3" type="audio/mpeg" />
              </audio>
              <audio className="incorrect-audio" autoPlay>
                <source src="./theme/audio/incorrect3.mp3" type="audio/ogg" />
                <source src="./theme/audio/incorrect3.mp3" type="audio/mpeg" />
              </audio>
            </div>
            <div className="container text-center heading-quiz new-quiz mx-auto">
              <div className="row">
                <div className="col-1">
                  <div
                    style={{ fontSize: "30px" }}
                    // onClick={() => this.onSetSidebarOpen(true)}
                  >
                    <i class="fas fa-bars"></i>
                    <br />
                  </div>
                </div>
                <div className="col m-0 d-flex justify-content-center mt-2 font-weight-bold">
                  <span className="not-responsive">Question</span>
                  {/* <h4>
                    {this.state.count + 1}/
                    {this.props.unitDetails.quiz_list[0].question_list.length}
                  </h4> */}
                </div>

                <div className="col mt-2">
                  <Line
                    percent={70}
                    strokeWidth="4"
                    strokeColor="#cf2667"
                  />
                </div>
                <div className="col m-0 mt-2">
                  <div className="row d-flex justify-content-center align-items-center navigation-button">
                    <div className="col" onClick={this.onBack}>
                      {this.state.count >= 1 ? (
                        <p className="next-btn m-0">
                          <i class="fas fa-arrow-left"></i>{" "}
                          <span className="not-responsive"> Previous</span>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col" onClick={this.onNext}>
                      <p className="back-btn m-0">
                        <span className="not-responsive">Next</span>{" "}
                        <i class="fas fa-arrow-right"></i>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-1 compress-btn d-flex justify-content-center mt-2">
                  <i class="fas fa-compress" onClick={this.onFullScreen}></i>
                </div>
              </div>
            </div>
          </div>
        </Fullscreen>
      </div>
    );
  }
}